(function($){
$bigImage = $('.big-image');
$bigImagemodule = $('.big_image_module');
$window = $(window);
var device;
var screenHeight = $(window).height();
var screenWidth = $(window).width();
window.onload=function(){
    setTimeout(function(){
        scrollTo(0,-1);
    },0);
}



function load_image(ruta) {
    var img = new Image();
    $(img).load(function(ruta) {
        //$(this).css('display', 'none'); // .hide() doesn't work in Safari when the element isn't on the DOM already
        $(this).hide();
        $('#outer_container #preload').fadeOut();
        $('#outer_container #pan_container').delay(250).html(this);
        //$(window).load();
        panThatImage();
        $(this).fadeIn('normal');
        $('#outer_container #close').fadeIn('normal', function() {
            /*$('#pane_wrapper').css('zIndex','3');*/
            /*$('#pane_wrapper').animate({top:'0px', bottom:'0px'},500,"easeInOutQuart");*/
        });
    }).error(function() {
        unPanIt();
        // notify the user that the image could not be loaded
    }).attr('src', ruta).attr('class', 'panning');
}

function onClickHandlerImgPaneHome(e) {
    var $tar = e.target
    var ruta = $(this).attr("data-image");
    $('#outer_container #close').hide();
    $('#outer_container #preload').fadeIn();
    $('#pane_wrapper').css('zIndex', '99').css('top', '0').css('bottom', '0');
    $('#pane_wrapper').fadeIn(1000, function() {
        load_image(ruta);
    });
    //ACCION CERRAR GALERIA
    $('#pane_wrapper').click(function() {
        $(this).fadeOut(300, function() {
            unPanIt();
            $('#pane_wrapper').css('top', '0px');
            $('#pane_wrapper').css('bottom', '0px');
            $('#outer_container #pan_container').html('');
            $(this).css('zIndex', '1');
        });
    });
    return false;
}

function resizeScreen() {
    screenHeight = $(window).height();
    screenWidth = $(window).width();
}
$(document).ready(function() {

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) device = 'mobile';
    else device = 'desktop';

    resizeScreen();
    scrollMagicBuild();
    $('.preloader').addClass('animate1');

    //$('.pane').on("click", onClickHandlerImgPaneHome);
    $('.square_wrapp_text').viewportChecker({
        classToAdd: 'visible',
        offset: 100,
        repeat: true,
        invertBottomOffset: false,
    });

    $('.video_section ').viewportChecker({
        classToAdd: 'visible',
        offset: 200,
        repeat: true,
        invertBottomOffset: false,
    });

});
  $(document).ready(function() {
      $('.square_wrapp_text').viewportChecker({
        classToAdd: 'visible',
        offset: 100,
        repeat: true,
        invertBottomOffset: false,
    });

    $('.video_section ').viewportChecker({
        classToAdd: 'visible',
        offset: 200,
        repeat: true,
        invertBottomOffset: false,
    });
     });
//SCROLL MAGIC
function scrollMagicBuild() {
    var scrollController = new ScrollMagic({
        refreshInterval: 200
    });
    TweenMax.to(".wrapper", 0.1, {
        backgroundColor: "#f2e9db"
    });
    var introTween = new TimelineMax().add([
        TweenMax.fromTo(".hero_img", 3, {
            css: {
                y: 0,
                opacity: 1
            }
        }, {
            css: {
                y: 40,
                opacity: 0.4
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".intro-text", 3, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            }
        }),
        TweenMax.fromTo(".triangle13", 3, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            }
        }),
        TweenMax.fromTo(".triangle1", 3, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -600
            }
        }),
        TweenMax.fromTo(".square_box1", 3, {
            css: {
                y: 50
            }
        }, {
            css: {
                y: -350
            }
        }),
    ]);
    var introScene = new ScrollScene({
        duration: $(".hero_banner_section").height()
    }).setTween(introTween).addTo(scrollController);

    var orange_section = new TimelineMax().add([
        TweenMax.fromTo(".orange_section", 2, {
            backgroundColor: "#f2e9db"
        }, {
            backgroundColor: "#ff8e6c"
        }),
        TweenMax.fromTo(".banner2", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".triangle2", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".triangle3", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".orange_1 .square_box2", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".orange_image2", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -700
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".orange_image3", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".triangle4j", 2, {
            css: {
                y: 200
            }
        }, {
            css: {
                y: -500
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".square_box3", 2, {
            css: {
                y: 200
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#letter_Eorang, .letter_u ", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#angle_orangnew", 2, {
            css: {
                y: 200
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#neworangimg1", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#org_triangle", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -250
            },
            ease: Power1.easeout
        }),

    ]);
    var fireScene = new ScrollScene({
        triggerElement: ".orange_section",
        duration: $(".video_section.orange_1").height()
    }).setTween(orange_section).addTo(scrollController);
    /////////////////
    var pink_section = new TimelineMax().add([
        TweenMax.fromTo(".pink_section", 1, {
            backgroundColor: "#ff8e6c"
        }, {
            backgroundColor: "#fa62a2",
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".wht-dwnarw.triangle", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".armsupimg11", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -280
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".pink-fireimg", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -500
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".letter-x.triangle", 2, {
            css: {
                y: 600
            }
        }, {
            css: {
                y: -900
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".pink-banner3, .armsupimg1", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -500
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".infodivv", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".square_box4", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".pink-back-img.triangle", 2, {
            css: {
                y: 600
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".borderdiv, .pink-sky_image3 .triangle.triangle4", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".pink-dwn-arw, .pinkprllel", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".blnk-dwnarw.triangle ", 2, {
            css: {
                y: 200
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
    ]);
    var redToYellowScene = new ScrollScene({
        triggerElement: ".pink_section",
        duration: $(".pink_section").height()
    }).setTween(pink_section).addTo(scrollController);
    /////////////////

    var sky_blue_section = new TimelineMax().add([
        TweenMax.fromTo(".sky_blue_section", 2, {
            backgroundColor: "#1CCAD4"
        }, {
            backgroundColor: "#1ccad4",
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".sky_blue1, #abt_trnglelst", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#abtltr_o", 2, {
            css: {
                y: 150
            }
        }, {
            css: {
                y: -600
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".sky_sqrBox", 2, {
            css: {
                y: 70
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".letter_u", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".tweeningg", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".sky_blue2, .skyblue-img.triangle, .triangle.triangle4.viewmoretriangle", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -500
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".sky_sqrBoxviewbtn", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -250
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".tweentrngl, #abt_trnglelst, .aboutblue #abtgirlright", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#abblankarrw", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".about-skyscroll #abttriangle1, #abttri2", 2, {
            css: {
                y: 250
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".letter_l, .abt_letter_r, .aboutblue #abtgirlleft", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -300
            },
            ease: Power1.easeout
        }),
    ]);
    var airScene = new ScrollScene({
        triggerElement: ".sky_blue_section",
        duration: $(".sky_blue_section ").height()
    }).setTween(sky_blue_section).addTo(scrollController);

//////////////////

    var voilet_section = new TimelineMax().add([
        TweenMax.fromTo(".voilet_section", 1, {
            backgroundColor: "#5F559A"
        }, {
            backgroundColor: "#7a2583",
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".abt_letter_s, #abttridwn", 2, {
            css: {
                y: 100
            }
        }, {
            css: {
                y: -400
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".vabtgirlsimg", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".vabttriangle1", 2, {
            css: {
                y: 200
            }
        }, {
            css: {
                y: -550
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".vabtgirlrightup", 2, {
            css: {
                y: 500
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#abtltr_e", 2, {
            css: {
                y: 300
            }
        }, {
            css: {
                y: -900
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#abblankarrwpup", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -200
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".letter_e1.letter_e", 2, {
            css: {
                y: 600
            }
        }, {
            css: {
                y: -900
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".frame1", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".frame", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -100
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo(".triangle12", 2, {
            css: {
                y: 0
            }
        }, {
            css: {
                y: -60
            },
            ease: Power1.easeout
        }),
    ]);
    var yellowToBlueScene = new ScrollScene({
        triggerElement: ".voilet_section",
        duration: $(".voilet_section ").height()
    }).setTween(voilet_section).addTo(scrollController);

      //////////////////

    var voilet_section = new TimelineMax().add([
        TweenMax.fromTo("#flvrslide-1", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 236
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-2", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-3", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
    ]);
    var yellowToBlueScene = new ScrollScene({
        triggerElement: ".to-fixed.flvr-one",
        duration: $(".to-fixed.flvr-one").height()
    }).setTween(voilet_section).addTo(scrollController);

  //////////////////

    var voilet_section = new TimelineMax().add([
        TweenMax.fromTo("#flvrslide-1", 2, {
            css: {
                x: 236
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-2", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 236
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-3", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
    ]);
    var yellowToBlueScene = new ScrollScene({
        triggerElement: ".to-fixed.flvr-two",
        duration: $(".to-fixed.flvr-two").height()
    }).setTween(voilet_section).addTo(scrollController);

      //////////////////

    var voilet_section = new TimelineMax().add([
        TweenMax.fromTo("#flvrslide-1", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-2", 2, {
            css: {
                x: 236
            }
        }, {
            css: {
                x: 0
            },
            ease: Power1.easeout
        }),
        TweenMax.fromTo("#flvrslide-3", 2, {
            css: {
                x: 0
            }
        }, {
            css: {
                x: 236
            },
            ease: Power1.easeout
        }),
    ]);
    var yellowToBlueScene = new ScrollScene({
        triggerElement: ".to-fixed.flvr-three",
        duration: $(".to-fixed.flvr-three").height() + 160
    }).setTween(voilet_section).addTo(scrollController);

}
  })(jQuery);